export const gtmDashboardSectionNames = {
	AVAILABLE_LEADS: 'tržiště',
	TAKEN_LEADS: 'převzato z tržiště',
	CAMPAIGNS: 'kampaně',
	TASKS: 'úkoly',
	LEADS: 'příležitosti',
	SEMAPHORE: 'semafor hrozící stav',
};

export const gtmFilterNames = {
	TAKEN: 'převzato',
	DRAFT: 'rozpracováno',
	CURRENT: 'aktuální',
};
